import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import botImg from '../assets/botFuncionando.png'; // asegurate de tener esta imagen en src/assets/

const BotDashboardInfo = () => {
  return (
    <section className="py-5" style={{ backgroundColor: '#fff9f1' }}>
      <Container>
        <Row className="align-items-center">
          <Col md={6}>
            <h2 className="mb-4">Tu asistente 100% conectado</h2>
            <p style={{ fontSize: '1.1rem' }}>
              Todo lo que el paciente hace por WhatsApp se refleja automáticamente en el Dashboard. 
              Desde una reserva, cancelación o consulta, hasta la confirmación de asistencia.
            </p>
          <ul style={{ fontSize: '1rem', paddingLeft: '1.2rem' }}>
            <li>📅 Reservá turnos en tiempo real desde el bot.</li>
            <li>🔁 Confirmá o cancelá turnos en un clic.</li>
            <li>✅ Recibí recordatorios automáticos antes del turno.</li>
            <li>👩‍💼 La recepcionista visualiza y gestiona todo al instante en el dashboard.</li>
            <li>📲 Sin apps ni instalaciones: funciona directo con tu WhatsApp.</li>
            <li>📨 Derivá la consulta a un representante si el paciente lo necesita.</li>
            <li>🔀 Opcional: redireccioná a otro número si el operador no está disponible.</li>
            </ul>
          </Col>
          <Col md={6}>
            <img
              src={botImg}
              alt="Funcionamiento del bot con el dashboard"
              className="img-fluid rounded shadow"
            />
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default BotDashboardInfo;
